import { useTranslation } from 'react-i18next';
import { getWhatsAppUrl } from '../utils/translation';

export const JoinButton = ({ url }: { url: string }) => {
    const { t } = useTranslation();
    return (
        <button
            className="join-button"
            onClick={() => window.open(url, '_blank')}
        >
            <img src="/icon/whatsapp-channel.svg" />
            {t('whatsappBanner.joinChannel')}
        </button>
    );
};

const WhatsAppBanner = () => {
    const { t } = useTranslation();
    const whatsAppUrl = getWhatsAppUrl();
    console.log(whatsAppUrl);

    if (!whatsAppUrl) {
        return null;
    }

    return (
        <div className="whatsapp-banner-container">
            <div className="padding">
                <div className="wrapper">
                    {/* Desktop/Large Screen Version */}
                    <div className="banner-large">
                        <div className="content">
                            <h2 className="title">
                                {t('whatsappBanner.discover')}{' '}
                                <span className="exclusive">
                                    {t('whatsappBanner.exclusive')}
                                </span>{' '}
                                {t('whatsappBanner.deals')}!!
                            </h2>
                            <p className="description">
                                {t('whatsappBanner.stayUpdatedWithLatestNews')}
                                <br />
                                {t('whatsappBanner.offersStraightToWhatsApp')}
                            </p>
                            <JoinButton url={whatsAppUrl} />
                        </div>
                        <div className="banner-image">
                            <img
                                src="/icon/whatsapp-banner.svg"
                                alt="WhatsApp Banner"
                                className="banner-img"
                            />
                        </div>
                    </div>

                    {/* Mobile/Small Screen Version */}
                    <div className="banner-small">
                        <h2 className="title-small">
                            {t('whatsappBanner.discover')}{' '}
                            <span className="exclusive">
                                {t('whatsappBanner.exclusive')}
                            </span>{' '}
                            {t('whatsappBanner.deals')}!!
                        </h2>
                        <div className="content-wrapper">
                            <div className="content-left">
                                <p className="description-small">
                                    {t(
                                        'whatsappBanner.getLatestCarNewsAmazingTips'
                                    )}
                                </p>
                                <JoinButton url={whatsAppUrl} />
                            </div>
                            <div className="banner-image-small">
                                <img
                                    src="/icon/whatsapp-banner-small.svg"
                                    alt="WhatsApp Banner Small"
                                    className="banner-img-small"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhatsAppBanner;
